import { Container, Carousel } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Icon from '~/components/Icon'
import Text from '~/components/Text'
import styled from 'styled-components'
import Box from '~/components/Box'
// import appendCDN from '~/utils/append_cdn_link'
import getcdn from "~/modules/get_cdn_link"
import breakpoints from '~/components/UI/breakpoints'
import SharedTitle from '~/components/UI/SharedTitle'
import { Trans } from '~/i18n'
import Img from '../UI/Image'

const MyContainer = styled(Container)`
  background-color: #f9fafc;
  padding: 64px 0;
`
// background-image:url(//djemclypbm8gi.cloudfront.net/static/about-us/nguyenthithuydung.jpg?ver=2)
const clients = (t: any) => ([
  {
    image: '/static/about-us/nguyenthithuydung.jpg?ver=2',
    text: t`Mình thấy thú vị với loại hình này, phù hợp với sở thích mua bán nhà cửa của mình. Thị trường BĐS năm nào cũng nói nổ bong bóng, nhưng chờ hoài không thấy nổ, năm nào giá nhà cũng tăng.`,
    name: t`Chị Nguyễn Thị Thùy Dung`,
    job: t`Giám đốc Kinh doanh`
  },
  {
    image: '/static/about-us/conghoa.jpg?ver=2',
    text: t`Kênh đầu tư khá mới cho giới văn phòng để gia tăng giá trị đồng tiền, thay vì gửi tiết kiệm ngân hàng. Cũng như thỏa mãn được nhu cầu muốn được đầu tư bất động sản của người Việt Nam.`,
    name: t`Anh Trịnh Công Hòa`,
    job: t`Nhà tư vấn đầu tư - Admin Blog Tài Chính Cá Nhân TienCuaToi.vn`
  },
  {
    image: '/static/about-us/nguyenhoaphuong.jpeg?ver=2',
    text: t`Giải pháp đầu tư an toàn, chăm sóc khách hàng tốt, đội ngũ founder uy tín.`,
    name: t`Chị Nguyễn Hoa Phương`,
    job: t`Nhân viên văn phòng`
  },
  {
    image: '/img/ToanVu.jpg?ver=2',
    text: t`Với 1 số tiền nhàn rỗi nhưng không quá lớn thì mình nghĩ đây là một hình thức đầu tư đáng để tiếp cận.`,
    name: t`Anh Trần Văn Vũ Toàn`,
    job: t`Lập trình viên`
  }
])

const ItemContainer = styled(Box)`
  max-width: 800px;
  margin: 20px;
  display: flex;
  border-radius: 4px;
  height: 570px;
  overflow: hidden;
  flex-direction: column;
  box-shadow: 0 2px 10px 0 rgba(0, 85, 255, 0.1);
  border: solid 1px rgba(26, 26, 26, 0.1);
  background-color: #ffffff;
  ${breakpoints.md} {
    height: 240px;
    flex-direction: row;
  }
`

const ImgContainer = styled.div`
  width: 100%;
  height: 240px;
  position: relative;
  flex-shrink: 0;
  ${breakpoints.md} {
    width: 240px;
  }
`

const StyledText = styled(Text)`
  font-style: italic;
`

const Hz = styled.div`
  height: 2px;
  background-color: #0055ff;
  width: 100%;
  max-width: 160px;
  margin: 27px 0;
`


const Control = styled(Icon)`
  font-size: 30px;
  color: #0055ff;
  display: none;
  ${breakpoints.md} {
    display: block;
  }
`


const Clients = () => {
  const [t] = useTranslation()
  const renderClients = () => {
    return clients(t).map(client => {
      return (
        <Carousel.Item key={client.name}>
          <Box flex justify='center'>
            <ItemContainer>
              {/* <ImgContainer style={{
                backgroundImage: `url(${appendCDN(client.image)})`
              }} /> */}
              <ImgContainer>
                <Img
                  src={getcdn(client.image)}
                  alt={client.name}
                  style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                />
              </ImgContainer>
              <Box style={{ padding: 34 }}>
                <StyledText>
                  {client.text}
                </StyledText>
                <Hz />
                <Text>
                  {client.name}
                </Text>
                <Text>
                  {client.job}
                </Text>
              </Box>
            </ItemContainer>
          </Box>
        </Carousel.Item>
      )
    })
  }
  return (
    <MyContainer fluid>
      <Container className='hp__client-root center'>
        <SharedTitle style={{ fontWeight: 'normal' }} centered>
          <Trans i18nKey='Khách hàng nói về Infina'>
          </Trans>
        </SharedTitle>
        <Carousel interval={null}
          prevIcon={<Control style={{ transform: 'rotate(180deg)' }} name='next-big' />}
          nextIcon={<Control name='next-big' />}
        >
          {renderClients()}
        </Carousel>
      </Container>
    </MyContainer>
  )
}

export default Clients
